import Pages from "./Pages";
import ConfigActionTypes from "./ConfigActionTypes";
// import FormFields from "./FormFields;"

const Enums = { Pages, ConfigActionTypes };

export default Enums;
